import React from 'react';
const modules = [{
  num: 1,
  title: 'Primer Mensaje que Convierte',
  subtitle: 'Qué decir cuando te escriben (sin quedar amateur)',
  desc: 'Cómo responder desde el primer contacto para generar interés y confianza.'
}, {
  num: 2,
  title: 'Cómo Decir el Precio sin Perder Ventas',
  subtitle: 'El momento donde la mayoría falla',
  desc: 'Scripts exactos para decir cuánto cobrás sin que te dejen de responder.'
}, {
  num: 3,
  title: 'Conversaciones que Cierran',
  subtitle: 'Cómo llevar un chat a una venta',
  desc: 'Paso a paso desde "hola" hasta "ya te pagué".'
}, {
  num: 4,
  title: 'Cierres que Hacen que te Compren YA',
  subtitle: 'Frases que activan la decisión',
  desc: 'Mensajes listos para cerrar sin ser insistente.'
}, {
  num: 5,
  title: 'Manejo de Objeciones',
  subtitle: 'Qué decir cuando dudan o no responden',
  desc: '"Lo pienso", "no tengo plata", "después te aviso"… resuelto.'
}, {
  num: 6,
  title: 'Seguimiento Inteligente',
  subtitle: 'Cómo insistir sin perder clientas',
  desc: 'Mensajes de seguimiento que reactivan conversaciones.'
}, {
  num: 7,
  title: 'Errores que te Hacen Perder Ventas',
  subtitle: 'Lo que estás diciendo (y te está saboteando)',
  desc: 'Frases y actitudes que bajan tu valor sin darte cuenta.'
}, {
  num: 8,
  title: 'Sistema Simple de Ventas por Chat',
  subtitle: 'Ordená tu proceso y vendé todos los días',
  desc: 'Estructura clara para no improvisar nunca más.'
}];
export function ModulesSection() {
  return <section className="px-4 py-12" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        <h2 className="mb-3 text-3xl font-bold text-center md:text-4xl text-white" data-id="element-146">
          ¿Qué agrega la{' '}
          <span className="text-brand-teal" data-id="element-147">Mentoría Tarot™</span>?
        </h2>
        <p className="mb-2 text-center text-lg font-medium text-white" data-id="element-148">
          El sistema que convierte tus lecturas en un servicio profesional que
          la gente elige y paga.
        </p>
        <p className="mb-8 text-center text-brand-dark/60 italic" data-id="element-149">
          Porque saber tarot no es suficiente… necesitás saber mostrarlo,
          comunicarlo y venderlo.
        </p>

        <div className="flex flex-col gap-4" data-id="element-150">
          {modules.map(mod => <div key={mod.num} className="p-5 rounded-xl bg-[#1a1a1a] border border-brand-teal/10" data-id="element-151">
              <div className="flex items-start gap-3" data-id="element-152">
                <span className="text-brand-teal text-lg mt-0.5" data-id="element-153">🔹</span>
                <div className="flex-1" data-id="element-154">
                  <h3 className="text-base font-bold text-white mb-1" data-id="element-155">
                    Módulo {mod.num} –{' '}
                    <span className="text-brand-teal" data-id="element-156">{mod.title}</span>
                  </h3>
                  <p className="text-sm text-brand-dark/70 italic mb-1" data-id="element-157">
                    {mod.subtitle}
                  </p>
                  <p className="text-sm text-brand-dark/60" data-id="element-158">👉 {mod.desc}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}